export class ComboAlunoTrabalhando {
	id: number;
	nome: string;
}